<template>
    <div class="row">
        <div class="col">
            <sub-section title="General assumptions" :showHelp="false">
                <ul class="fa-ul">
                    <li v-for="(assumption, i) in textArray('modelling.assumptions.general.description')" :key="i">
                        {{ assumption }}
                    </li>
                </ul>

                <div class="alert alert-primary" role="alert">
                    <i class="bi bi-check-circle-fill"></i>
                    It is very important to understand that in reality actual experience will always differ from
                    these assumptions at least to some degree. The test page on the website is designed to allow you
                    to consider various common scenarios which may occur which may affect your design. You should
                    revisit your design each year to consider if it is still on course to provide what you want in
                    retirement.
                </div>
            </sub-section>
        </div>
    </div>
</template>

<script setup lang="ts">
import SubSection from '../common/SubSection.vue';
import { useUIContent } from "@/guiide/ts/configuration/useUIContent";

const { textArray } = useUIContent();

</script>
